<template>
  <div class="app-container">
    <list ref="list">
       
       
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/materialdetailed/list'


export default {
  name: 'materialdetailed',
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  
};
</script>